"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCloudUpload = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M54 21.58a14.48 14.48 0 0 0-3.25.37 18.32 18.32 0 0 0-34.62 4.85 12.13 12.13 0 0 0-2.69-.3 12 12 0 0 0 0 24h12.72a1.6 1.6 0 0 0 0-3.2H13.44a8.77 8.77 0 1 1 3.45-16.86A1.6 1.6 0 0 0 19.11 29a15.12 15.12 0 0 1 29.25-4.56 1.6 1.6 0 0 0 2 1 11.31 11.31 0 1 1 3.65 22H42.86a1.6 1.6 0 0 0 0 3.2H54a14.51 14.51 0 0 0 0-29z"
  }), _react["default"].createElement("path", {
    d: "M44.13 42.09a1.6 1.6 0 1 0 2.26-2.26L35.7 29.14a1.65 1.65 0 0 0-2.26 0l-10.7 10.69A1.6 1.6 0 0 0 25 42.09l8-8V57a1.6 1.6 0 1 0 3.2 0V34.13z"
  })),
  height: undefined,
  width: undefined
});
IconCloudUpload.displayName = 'IconCloudUpload';
var _default = IconCloudUpload;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/cloud-upload.js
// module id = 564
// module chunks = 0